




















































import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import Media from '../api/media';
import {loadFile} from '@/util/file';
import {BusEvent} from '@/models/bus';
import {MediaFileField} from '../models/fields';
import EditIcon from '@/components/icons/EditIcon.vue';
import FileIcon from '@/components/icons/FileIcon.vue';

@Component({
    components: {
        'edit-icon': EditIcon,
        'file-icon': FileIcon,
    },
})
export default class FieldImage extends Vue implements MediaFileField {
    @Prop({type: String}) public src?: string;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    // allow the user to unselect the image after being chosen
    @Prop({type: Boolean, default: true}) public allowUnselection!: boolean;
    @Prop({type: File, default:null}) public initialFile!: File|null;


    // used so inputs don't interfere with each other
    public static counter: number = 0;
    public uniqueId: string = 'field-image' + FieldImage.counter++;

    public file: File | null = this.initialFile;
    public preview: any = null;
    public changed: boolean = false;

    @Watch('src')
    public updateId() {
        this.uniqueId = 'field-image' + FieldImage.counter++;
        this.file = null;
        this.preview = null;
        this.changed = false;
    }

    public async onFileChange(name: string, files: FileList): Promise<void> {
        if (files.length === 0) {
            this.file = null;
            this.preview = null;
        } else {
            const file = files.item(0);
            if (file === null) {
                return;
            }

            if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
                this.clear();
                this.file = file;
                this.preview = await loadFile(file);
                this.changed = true;
                this.$emit('NewFile', file);
            } else {
                this.$bus.$emit(
                    BusEvent.ERROR,
                    'Image Error',
                    new Error(`Unsupported image format: ${file.name}. Please use .jpe .jpeg .png or .gif`)
                );
            }
        }
    }

    public getFileName() {
        if (this.file) {
            return this.file.name;
        } else {
            return 'No new file';
        }
    }

    /**
     * Upload the image.
     * Will throw an error if there is nothing to upload.
     *
     * @param {string} parentModel
     *     Parent model slug, e.g. Module.SLUG.
     * @param {number} parentId
     *     Parent object identifier.
     *     This means you have to create the parent entity on the server
     *     before you can call this method!
     * @param {string} fieldName
     *     e.g. bg_image icon
     * @returns {Promise<number>}
     *     Identifier of a Media entity.
     */
    public async upload(parentModel: string, parentId: number, fieldName: string): Promise<number> {
        if (!parentModel || parentId === null) {
            // Uploading files is only possible after the parent entity has been created
            throw Error('Missing parent information.');
        }

        if (!this.file) {
            throw Error('Image has not changed, nothing to upload.');
        }
        return await Media.createImage(
            this.file,
            parentModel,
            parentId,
            fieldName
        );
    }

    public clear(e?) {
        if (e) {
            e.stopPropagation();
        }
        if (!this.disabled) {
            // only emit  delete event the first time the cross is clicked
            if (!this.changed && this.src) {
                this.$emit('DeleteMedia', 'image');
            }

            this.changed = true;
            this.file = null;
            this.preview = null;
        }
    }

    public hasMedia(): boolean {
        return (this.src && !this.changed) || (this.changed && !!this.file);
    }

    public hasNewMedia(): boolean {
        return !!this.file;
    }


    public inputClicked() {
        this.$emit('InputClicked');
        // (this.$refs.label as HTMLElement).click();
    }
}
